// source: external/dialer/nxExtenManage.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_dialer_pb = require('../../xcommon/dialer_pb.js');
goog.object.extend(proto, xcommon_dialer_pb);
var xcommon_common_pb = require('../../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_nxExtenManage_pb = require('../../xcommon/nxExtenManage_pb.js');
goog.object.extend(proto, xcommon_nxExtenManage_pb);
var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js');
goog.object.extend(proto, xcommon_ticket_pb);
